export type AnalysisType =
  | 'geral'
  | 'descritiva'
  | 'comparativa'
  | 'correlacional'
  | 'evolutiva'
  | 'outro';

export type ResearchObjective =
  | 'todos'
  | 'impacto_comunicacao'
  | 'evolucao_aprendizagem'
  | 'comparacao_contextos'
  | 'eficacia_ferramenta'
  | 'engajamento_uso'
  | 'outro_objetivo';

export interface ScientificAnalysis {
  id: string;
  title: string;
  types: AnalysisType[];
  customTypeLabel?: string;
  researchObjectives: ResearchObjective[];
  eventIds: string[];
  createdBy: string;
  collaboratorEmails: string[];
  createdAt: string;
  status: 'rascunho' | 'concluida';
}

export interface CreateAnalysisInput {
  title: string;
  types: AnalysisType[];
  customTypeLabel?: string;
  researchObjectives: ResearchObjective[];
  eventIds: string[];
  collaboratorEmails: string[];
}

/** Cruzar dados exige pelo menos dois eventos — com um só não há o que comparar. */
export const MIN_EVENTS_FOR_ANALYSIS = 2;

export const ANALYSIS_TYPE_LABELS: Record<AnalysisType, string> = {
  geral: 'Todos (visão geral)',
  descritiva: 'Estatística descritiva',
  comparativa: 'Comparação entre grupos',
  correlacional: 'Correlação',
  evolutiva: 'Evolução temporal',
  outro: 'Outro',
};

export const RESEARCH_OBJECTIVE_LABELS: Record<ResearchObjective, string> = {
  todos: 'Todos (visão geral)',
  impacto_comunicacao: 'Impacto na comunicação funcional',
  evolucao_aprendizagem: 'Evolução de aprendizagem entre coletas',
  comparacao_contextos: 'Comparação entre contextos escolares',
  eficacia_ferramenta: 'Eficácia e disseminação da ferramenta',
  engajamento_uso: 'Engajamento e tempo de uso',
  outro_objetivo: 'Outro objetivo',
};

export const ANALYSIS_METHOD_BY_TYPE: Record<AnalysisType, string> = {
  geral: 'Panorama completo: descritiva + comparativa + série temporal para todos os eventos',
  descritiva: 'Média, mediana, desvio padrão e frequência por módulo',
  comparativa: 'Teste t de Student pareado (pré/pós) ou ANOVA para múltiplos grupos',
  correlacional: 'Correlação de Pearson (r) ou Spearman (ρ) para dados ordinais',
  evolutiva: 'Análise de séries temporais; regressão linear por período',
  outro: 'Método a definir conforme o delineamento do estudo',
};

export function analysisTypeLabel(a: ScientificAnalysis): string {
  if (!a.types || a.types.length === 0) return 'Sem método definido';
  return a.types
    .map((t) => (t === 'outro' && a.customTypeLabel ? a.customTypeLabel : ANALYSIS_TYPE_LABELS[t]))
    .join(' · ');
}

export function researchObjectivesLabel(objs: ResearchObjective[]): string {
  if (!objs || !objs.length) return 'Não especificado';
  return objs.map((o) => RESEARCH_OBJECTIVE_LABELS[o]).join(' · ');
}
